import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Browse from "@/pages/Browse";
import KitchenDetail from "@/pages/KitchenDetail";
import CookDashboard from "@/pages/CookDashboard";
import OwnerDashboard from "@/pages/OwnerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import CreateKitchen from "@/pages/CreateKitchen";
import Messages from "@/pages/Messages";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import ChefPortfolio from "@/pages/ChefPortfolio";
import ChefProfileEdit from "@/pages/ChefProfileEdit";
import CorporateDashboard from "@/pages/CorporateDashboard";
import FindChef from "@/pages/FindChef";
import CompareChefs from "@/pages/CompareChefs";
import StateLanding from "@/pages/StateLanding";
import Trends from "@/pages/Trends";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="tick-label p-10">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#141414", color: "#fff", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 2 } }} />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/kitchen/:id" element={<KitchenDetail />} />
            <Route path="/list-your-kitchen" element={<Protected role="owner"><CreateKitchen /></Protected>} />
            <Route path="/cook" element={<Protected role="cook"><CookDashboard /></Protected>} />
            <Route path="/owner" element={<Protected role="owner"><OwnerDashboard /></Protected>} />
            <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
            <Route path="/messages/:bookingId" element={<Protected><Messages /></Protected>} />
            <Route path="/chef/:chefId" element={<ChefPortfolio />} />
            <Route path="/find-a-chef" element={<FindChef />} />
            <Route path="/compare-chefs" element={<CompareChefs />} />
            <Route path="/kitchens/:stateCode" element={<StateLanding />} />
            <Route path="/trends" element={<Trends />} />
            <Route path="/cook/profile" element={<Protected role="cook"><ChefProfileEdit /></Protected>} />
            <Route path="/corporate" element={<Protected><CorporateDashboard /></Protected>} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
